import React from "react";

const Police =()=>{

    return(
        <div className="regulations-detail">
            <div>
                <div className="box-list-style">Chào mừng Quý khách đến với Bibo Mart - Hệ thống bán lẻ đa kênh dành cho Mẹ và Bé hàng đầu Việt Nam (Sau đây gọi tắt là Bibo).</div>
                <ul className="pdl-20">
                    <li>Bibo hiện có hệ thống cửa hàng bán lẻ phủ khắp các tỉnh thành trên toàn quốc.</li>
                    <li>Ngoài ra chúng tôi có website <a className="text-red" href="https://bibomart.com.vn/">bibomart.com</a> và App Bibo là trang web và ứng dụng chính thức được xây dựng nhằm phục vụ Khách hàng mua hàng và tìm hiểu thông tin về Bibo.</li>
                    <li>Khi đăng ký và đăng nhập vào Website và App Bibo, Quý khách cần tìm hiểu và tuân thủ các Quy định sử dụng Web và App này (sau đây gọi tắt là Quy định sử dụng).</li>
                </ul>
                </div>
                <div>
                <div >
                    <div>
                    <b className="index">1. Hiệu lực của Quy định sử dụng</b>
                    </div>
                </div>
                <div className="box-list-style">
                    <ul className="pdl-20">
                        <li>Các điều kiện, điều khoản và nội dung của trang website/app này được xây dựng và điều chỉnh trên cơ sở tuân thủ các quy định của pháp luật và với mục đích xây dựng môi trường kinh doanh lành mạnh, minh bạch vì lợi ích của Khách hàng và Đối tác hợp tác cùng Bibo Mart.</li>
                        <li>Quý khách vui lòng đọc kỹ và xác nhận đồng ý với các điều khoản và điều kiện của Quy định sử dụng này để được cấp tài khoản thành viên của Bibo Mart.</li>
                        <li>Các điều khoản của Quy định này và các Chính sách liên quan có thể được điều chỉnh theo quy định của pháp luật nhằm đảm bảo tuân thủ pháp luật và theo thực tế hoạt động của Bibo nhằm nâng cao trải nghiệm Khách hàng. Bibo có toàn quyền điều chỉnh Quy định này mà không thông báo trước.</li>
                        <li>Vui lòng kiểm tra email, website và app thường xuyên để cập nhật các thay đổi (nếu có) của Quy định và Chính sách này.</li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <b className="index">2. Thoả thuận tuân thủ Quy định sử dụng</b>
                </div>
                <div className="box-list-style">
                    <ul className="pdl-20">
                        <li>Bibo cấp tài khoản Website và App để Quý khách sử dụng <span className="red">với điều kiện người được cấp tài khoản phải tuân thủ Điều khoản và Điều kiện trong Quy định này</span>. Quý khách chỉ đăng nhập và mua sắm nếu chấp thuận các Quy định này.</li>
                        <li>Nếu vi phạm bất cứ điều nào trong Quy định này, Bibo có quyền vô hiệu tài khoản của người dùng mà không cần báo trước. </li>
                        <li>Bibo không chịu bất kỳ trách nhiệm nào, dù trực tiếp hay gián tiếp, đối với những thiệt hại hoặc mất mát gây ra do người dùng không tuân thủ Quy định.</li>
                        <li>Khi truy cập vào Website và App của Bibo, người dùng tối thiểu phải 18 tuổi hoặc truy cập dưới sự giám sát của cha mẹ hay người giám hộ hợp pháp.</li>
                        <li>Quý khách phải đăng ký tài khoản với thông tin chính xác về bản thân và phải cập nhật thông tin nếu có bất kỳ thay đổi nào ở mục “Tài khoản” trên App.</li>
                        <li>Mỗi cá nhân truy cập phải có trách nhiệm với mật khẩu, tài khoản và hoạt động của mình. Vui lòng, thông báo ngay cho Bibo nếu tài khoản bị truy cập trái phép. </li>
                        <li>Nghiêm cấm sử dụng bất kỳ phần nào của trang Website và App này với mục đích trục lợi hoặc phá hoại nếu không được Bibo Mart cho phép bằng văn bản.</li>
                        <li>Bằng việc đăng ký thành viên, Quý khách đồng ý nhận thông báo Chăm sóc khách hàng, Tin tức, cập nhật đơn hàng và Khuyến mại ... từ Bibo Mart qua email, Zalo, SMS và noti App. Nếu không muốn tiếp tục nhận thông báo, Quý khách có thể thiết lập <u className="red">“Từ chối nhận thông báo"</u> ở phần “Tài khoản” của App.</li>
                    </ul>
                </div>
            </div>
            <div>
                <div >
                    <b className="index">3. Thương hiệu và bản quyền thương hiệu</b>
                </div>
                <div className="box-list-style">
                    <ul className="pdl-20">
                        <li>Bibo Mart là thương hiệu đã được đăng ký sở hữu trí tuệ và được bảo hộ ở nhiều quốc gia.</li>
                        <li>Mọi thông tin trên App và Web Bibo Mart bao gồm và không giới hạn ở: hình ảnh, video, thiết kế đồ hoạ, văn bản, âm nhạc, âm thanh, phần mềm, mã nguồn ... (dù đã đăng ký hay chưa đăng ký) đều là tài sản trí tuệ của Bibo Mart, được bảo vệ bởi Luật bản quyền và sở hữu trí tuệ của Việt Nam và quốc tế.</li>
                        <li>Mọi hành vi sao lưu, sử dụng khi chưa được sự cho phép bằng văn bản của Bibo Mart đều vi phạm và bị xử lý theo quy định của pháp luật.</li>
                    </ul>
                </div>
            </div>
            <div>
                <div >
                    <b className="index">4. Bảo mật thông tin</b>
                </div>
                <div className="box-list-style">
                    <ul className="pdl-20">
                        <li>Bibo coi trọng việc bảo mật thông tin và luôn sử dụng các biện pháp tốt nhất bảo vệ thông tin cá nhân và mọi giao dịch của Quý khách. Mọi thông tin liên quan đến Khách hàng đều được mã hóa để đảm bảo quyền lợi cho Quý khách và cho hệ thống thông tin của Bibo.</li>
                        <li>Bibo nghiêm cấm mọi hành vi sử dụng chương trình phần mềm, công cụ hay hình thức nào khác để can thiệp vào hệ thống thông tin, đánh cắp, phá hoại hoặc thay đổi cấu trúc dữ liệu của hệ thống. Cá nhân hay tổ chức vi phạm sẽ bị huỷ bỏ mọi quyền lợi hiện có ở Bibo Mart cũng như sẽ bị xử lý theo Quy định của pháp luật.</li>
                        <li>Bibo cam kết bảo vệ và không cung cấp thông tin của Quý khách cho bên thứ ba. Trừ trường hợp:
                        <ul className="pdl-20">
                            <li>Được yêu cầu cung cấp thông tin bởi cơ quan chức năng của Nhà nước.</li>
                            <li>Cung cấp số điện thoại và địa chỉ của Khách hàng cho nhân viên giao nhận để giao hàng cho Khách hàng.</li>  
                        </ul>
                        </li>
                        <li>Xem thêm tại <a className="text-red" href="/informationsecurity.html">Chính sách Bảo mật thông tin</a></li>
                    </ul>
                </div>
            </div>
            <div>
                <div >
                    <b className="index">5. Quyền sở hữu với phản hồi từ Khách hàng</b>
                </div>
                <div className="box-list-style">
                    <ul className="pdl-20">
                        <li>Các ý kiến bình luận (comment), phản hồi (feedback), đánh giá (review)... từ Khách hàng cho Bibo trên các kênh của Bibo sẽ được ghi nhận là tài sản của Bibo Mart. Bibo có toàn quyền sở hữu và sử dụng các ý kiến này mà không cần thông báo cho Khách hàng.</li>
                        <li>Bibo trân trọng mọi ý kiến đóng góp từ Khách hàng với tinh thần xây dựng, thiện chí và tuân thủ theo Quy định chung của Pháp luật Việt Nam. Các tài khoản đưa ra ý kiến phản hồi không mang tính xây dựng và gây tổn hại uy tín của các đối tác và của Bibo, tác động tiêu cực đến các Khách hàng khác sẽ bị vô hiệu tài khoản.</li>
                        <li>Nếu Bibo tiếp nhận ý kiến nào từ Khách hàng từ tài khoản nghi ngờ giả mạo, Bibo sẽ thông tin tới Quý khách hàng, đồng thời sẽ khoá tài khoản đó nhằm bảo vệ tài khoản của Quý khách cũng như bảo vệ hệ thống thông tin của Bibo Mart.</li>
                    </ul>
                </div>
            </div>
            <div>
                <div >
                    <b className="index">6. Mua hàng và thanh toán</b>
                </div>
            <div >
                <div>Khách hàng mua sắm thông qua App/Web của Bibo Mart cần thực hiện theo trình tự như sau:</div>
                    <div className="box-list-style">
                        <u>6.1. Thanh toán sau khi nhận hàng (COD)</u>
                        <ul className="pdl-20">
                            <li>Bước 1: Khách hàng đặt hàng, cung cấp đầy đủ thông tin và xác nhận đơn hàng.</li>
                            <li>Bước 2: Bibo kiểm tra, xác thực đơn hàng và thông tin Khách hàng.</li>
                            <li>Bước 3: Bibo đóng gói và giao hàng cho đơn vị vận chuyển thứ ba.</li>
                            <li>Bước 4: Đơn vị vận chuyển liên hệ Quý khách để giao hàng.</li>
                            <li>Bước 5: Quý khách nhận hàng và thanh toán cho người giao hàng.</li>
                            <li>Bước 6: Khách hàng kiểm tra, đánh giá, phản hồi cho Bibo sau mua hàng qua App.</li>
                            <li>Bước 7: Hoàn tất đơn hàng.</li>
                        </ul>
                    </div>
                    <div className="box-list-style">
                        <u>6.2. Thanh toán trước khi nhận hàng:</u>
                        <ul className="pdl-20">
                            <li>Bước 1: Khách hàng đặt hàng, cung cấp đầy đủ thông tin và xác nhận đơn hàng.</li>
                            <li>Bước 2: Bibo kiểm tra, xác thực đơn hàng và thông tin Khách hàng. Thông báo cho Khách hàng số tiền cần thanh toán.</li>
                            <li>Bước 3: Quý khách chuyển khoản thanh toán cho Bibo về <span >Số tài khoản</span> mà hệ thống thông báo qua tin nhắn.</li>
                            <li>Bước 4: Bibo nhận tiền, đóng gói và giao hàng cho đơn vị vận chuyển thứ ba.</li>
                            <li>Bước 5: Đơn vị vận chuyển liên hệ Quý khách để giao hàng.</li>
                            <li>Bước 6: Quý khách nhận hàng, kiểm tra, đánh giá và phản hồi cho Bibo qua App</li>
                            <li>Bước 7: Hoàn tất đơn hàng.</li>
                        </ul>
                    </div>
                    <div>Khách hàng có thể tra cứu tình trạng đơn hàng đã đặt trên App Bibo Mart hoặc liên hệ P. CSKH qua Hotline 1800 6886 để được hỗ trợ.</div>
                </div>
            </div>
            <div>
                <div >
                    <b className="index">7. Quyền lợi và nghĩa vụ của Khách hàng</b>
                </div>
                <div >
                    <div className="box-list-style">
                        <u>Quyền lợi:</u>
                        <ul className="pdl-20">
                            <li>Huỷ bỏ giao dịch nếu Bibo không đáp ứng được các giao kết sau khi thông báo cho Bibo Mart qua App hoặc Hotline.</li>
                            <li>Nhận hoá đơn VAT điện tử tại <a className="text-red" href="https://bibomart.com.vn/huong-dan-tra-cuu-hoa-don-dien-tu" >website</a></li>
                            <li>Được bảo hành sản phẩm theo <a className="text-red" href="bibomart://policy-warrantyPolicy" >Chính sách Bảo hành</a></li>
                            <li>Đổi/Trả hàng đã mua theo <a className="text-red" href="https://bibomart.com.vn/chinh-sach-doi-hang" >Chính sách Đổi trả</a></li>
                        </ul>
                    </div>
                    <div className="box-list-style">
                    <u>Nghĩa vụ:</u>
                    <ul>
                        <li>Cung cấp đầy đủ thông tin và số điện thoại liên hệ để phục vụ cho việc liên lạc để giao hàng và chăm sóc hậu mãi.</li>
                        <li>Chịu phí giao hàng trong trường hợp đổi ý và huỷ đơn hàng mà không do lỗi của Bibo hoặc bên giao nhận.</li>
                    </ul>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <b className="index">8. Quyền lợi và nghĩa vụ của Bibo</b>
                </div>
                <div>
                    <div className="box-list-style">
                        <u>Quyền lợi:</u>
                        <ul className="pdl-20">
                            <li>Bibo cam kết bán đúng giá niêm yết trên App/Web. Trừ các trường hợp bất khả kháng như lỗi kỹ thuật và lỗi đồng bộ hệ thống phần mềm, dẫn đến sai lệch tồn kho/giá bán/khuyến mại ... Trong trường hợp này, chúng tôi sẽ liên hệ để thông tin tới Khách hàng sau khi nhận đơn hoặc/và hướng dẫn Khách hàng các bước huỷ đơn hàng đã đặt.</li>
                            <li>Bibo có quyền từ chối hoặc huỷ đơn hàng sau khi nhận đơn đặt hàng và được miễn trừ trách nhiệm liên quan trong các trường hợp bất khả kháng như thiên tai, dịch bệnh, hệ thống và phần mềm bị tấn công...</li>
                        </ul>
                    </div>
                    <div className="box-list-style">
                        <u>Nghĩa vụ:</u>
                        <ul className="pdl-20">
                            <li>Đảm bảo quyền sở hữu hợp pháp đối với hàng hoá kinh doanh và quyền chuyển giao sở hữu hàng hoá cho Khách hàng.</li>
                            <li>Đảm bảo 100% hàng hoá kinh doanh đảm bảo chất lượng, tuân thủ quy định của pháp luật khi lưu thông trên thị trường.</li>
                            <li>Giao hàng đúng số lượng, giá cả, đúng đối tượng, đúng thời gian và địa điểm.</li>
                            <li>Giao hàng kèm hoá đơn và chứng từ.</li>
                            <li>Bảo hành theo Quy định.</li>
                            <li>Hỗ trợ và giải quyết mọi khiếu nại từ Khách hàng sau khi giao hàng.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <b className="index">9. Giải quyết khiếu nại và tranh chấp</b>
                </div>
                <div className="box-list-style">
                    <ul className="pdl-20">
                        <li>Phòng Chăm sóc Khách hàng, thông qua Hotline 1800 6886 là đầu mối tiếp nhận ý kiến phản hồi, khiếu nại từ Khách hàng về hàng hoá, giá cả, dịch vụ ... của Bibo Mart.</li>
                        <li>Bibo cam kết cùng các bên liên quan phản hồi và giải quyết trong vòng 24h kể từ khi nhận được ý kiến khiếu nại và cam kết hành động với trách nhiệm cao nhất vì quyền lợi của Khách hàng.</li>
                        <li>Bất kỳ tranh chấp, khiếu nại phát sinh giữa Khách hàng và Bibo Mart hoặc liên quan đến các Quy định này sẽ ưu tiên giải quyết bằng hình thức thương lượng, hòa giải.</li>
                        <li>Trường hợp không thể thương lượng hoặc hoà giải, vụ việc sẽ được giải quyết bởi trọng tài và/hoặc Tòa án theo Quy định của Pháp luật.</li>
                    </ul>
                </div>
            </div>
            
        </div>
    )
}

export default Police